var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    height: 512,
    fill: "#2d6e58",
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_129",
    d: "m362 0h-212c-82.84 0-150 67.16-150 150v212c0 82.84 67.16 150 150 150h212c82.84 0 150-67.16 150-150v-212c0-82.84-67.16-150-150-150zm1.89 333.57-90.21 90.21c-9.76 9.76-25.59 9.76-35.36 0l-90.21-90.21c-9.76-9.76-9.76-25.59 0-35.36 9.76-9.76 25.59-9.76 35.36 0l72.53 72.53 72.53-72.53c9.76-9.76 25.59-9.76 35.36 0 9.76 9.76 9.76 25.59 0 35.36zm0-119.79c-9.76 9.76-25.59 9.76-35.36 0l-72.53-72.53-72.53 72.53c-9.76 9.76-25.59 9.76-35.36 0-9.76-9.76-9.76-25.59 0-35.36l90.21-90.21c9.76-9.76 25.59-9.76 35.36 0l90.21 90.21c9.76 9.76 9.76 25.59 0 35.36z",
    "data-name": 129
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.f86ff9893b86bac6975fc09a0f924adb.svg";
export { ForwardRef as ReactComponent };